import React from 'react';

import type { TodoItem } from '../../types';
import { getDisplayTime } from './helpers';
import styles from './index.module.scss';

const DELETE_ICON_PATH = 'icon/ic_delete.svg';
const EDIT_ICON_PATH = 'icon/ic_edit.svg';

type TodoListProps = {
  list: TodoItem[];
  handleEditTodoButtonClick: (todoItem: TodoItem) => void;
  openDeleteConfirmModal: (id: string) => void;
};

const TodoList = ({
  list,
  handleEditTodoButtonClick,
  openDeleteConfirmModal,
}: TodoListProps) => {
  return (
    <ul className={styles.todoList}>
      <div className={styles.todoListTitleContainer}>
        <p>待辦事項列表</p>
      </div>
      {list.length === 0 ? (
        <div className={styles.noDataContainer}>
          <h2>目前尚無待辦事項</h2>
        </div>
      ) : (
        list.map((todoItem) => {
          const { id, title, remindTime } = todoItem;
          const { amPm, hh, mm } = getDisplayTime(remindTime);

          return (
            <li key={id} className={styles.todoItem}>
              <div className={styles.itemTitleAndTimeContainer}>
                <h5>{title}</h5>
                <div className={styles.timeDisplayContainer}>
                  <p>{amPm}</p>
                  <p>{`${hh}:${mm}`}</p>
                </div>
              </div>
              <div className={styles.actionButtonsContainer}>
                <button onClick={() => openDeleteConfirmModal(id)}>
                  <img src={DELETE_ICON_PATH} alt="刪除icon" />
                </button>
                <button onClick={() => handleEditTodoButtonClick(todoItem)}>
                  <img src={EDIT_ICON_PATH} alt="編輯icon" />
                </button>
              </div>
            </li>
          );
        })
      )}
    </ul>
  );
};

export default TodoList;
